import DynamoModel from "./dynamo";
import { requiredFieldNames } from '../common/Utilities';

export default class Survey extends DynamoModel {

    // requiredColumns = columns => columns.L.filter((c) => c.M.RequiredColumn && c.M.RequiredColumn.BOOL && (typeof(c.M.Nullable.BOOL) === "undefined" || !c.M.Nullable.BOOL));
    // optionalColumns = columns => columns.L.filter((c) => {
    //     var aa = !(c.M.RequiredColumn && c.M.RequiredColumn.BOOL && (typeof(c.M.Nullable.BOOL) === "undefined" || !c.M.Nullable.BOOL));
    //     return aa;
    // });

    requiredColumns = columns => columns.L.filter((c) => (c.M.RequiredColumn && c.M.RequiredColumn.BOOL) /*|| (c.M.DataType.S === "Separator")*/);

    // optionalColumns = columns => columns.L.filter((c) => {
    //     var aa = !(c.M.RequiredColumn && c.M.RequiredColumn.BOOL && (typeof(c.M.Nullable.BOOL) === "undefined" || !c.M.Nullable.BOOL));
    //     return aa;
    // });
    optionalColumns = columns => columns.L.filter(c => (!(c.M.TemplateDefault && c.M.TemplateDefault.BOOL) && !(c.M.RequiredColumn && c.M.RequiredColumn.BOOL)));
    templateDefaultColumns = columns => columns.L.filter(c => c.M.TemplateDefault && c.M.TemplateDefault.BOOL && !c.M.RequiredColumn.BOOL);
    //optionalColumns = columns => columns.L.filter((c) => true);

    constructor() {

        super();

        this.dbObject = {
            jobNumVendor: { S: "" },
            client: { S: "" },           
            schemaDTS: { S: "" },
            surveyState: { S: "" },
            technicians: { L: [] },
            Templates: { L: [] },                     
            projDesc: { S: "" },         
            surveyActivity: { S: "" },           
            surveyArea: { S: "" },
            createdBy: { S: ""},
            editedBy: { S: ""}
        };
    
        this.simpleObject = {
            jobNumVendor: "",
            client: "",         
            schemaDTS: "",
            surveyState: "Active", // default
            technicians: [],
            Templates: { L: []},                    
            projDesc: "",         
            surveyActivity: "",          
            surveyArea: "",
            createdBy: "",
            editedBy: ""
        };
    }
    getDbObject = () => this.dbObject;
    getSimpleObject = () => {
        // set all the help methods on the new simpleObject
        this.setHelperMethods();
        return this.simpleObject
    };

    fromSimple = (data) => {
        // deep clone
        this.simpleObject = JSON.parse(JSON.stringify(data));
        
        // set all the help methods on the new simpleObject
        this.setHelperMethods();
        
        this.setS("jobNumVendor");
        this.setS("client");      
        this.setS("schemaDTS");
        this.setS("surveyState");
        this.setSList("technicians");
        
        this.dbObject.Templates = JSON.parse(JSON.stringify(this.simpleObject.Templates));
        // AWS does not allow for empty length strings on properties, so we are deleting them prior
        // to trying to push to AWS
        this.dbObject.Templates.L.forEach((templateItem) => {
            templateItem.M.Columns.L.forEach((item) => {
                let deletes = [];
                for(const prop in item.M) {
                    if (item.M[prop].S === "") {
                        deletes.push(prop);
                    } else if (item.M[prop].N === "") {
                        deletes.push(prop);
                    }
                }
                deletes.forEach((delProp) => {
                    delete item.M[delProp];
                });
            });
        });       
       // this.setS("jobnumclient");
        this.setS("projDesc");
        //this.setS("projName");
        this.setS("surveyActivity");
        //this.setS("surveyName");
        this.setS("surveyArea");
        this.setS("createdBy");
        this.setS("editedBy");
        return this;
    };

    setHelperMethods = () => {
        
        if (this.simpleObject && !this.simpleObject.templateExists) {

            let item = this.simpleObject;

            // Set up helper methods
            item.templateCount = () => item.Templates.L.length;

            // Does a template exist in the survey.Templates collection
            item.templateExists = (templateName) =>
                item.Templates && item.Templates.L && item.Templates.L.length > 0 && item.Templates.L.filter((t) =>
                    t.M.Value.S === templateName).length > 0;

            item.removeTemplatesNotInList = (templates) => {
                for (let i=item.Templates.L.length-1; i>=0; i--) {
                    if (templates.filter(t => t === item.Templates.L[i].M.Value.S).length === 0) {
                        item.Templates.L.splice(i,1);
                    }
                };
            }

            // Templates.L[ M: { Columns {L:[]}, Value: {S: ""}, Label: {S: ??} } ]
            item.addTemplateIfMissing = (key, avType,label) => {
                if (!item.templateExists(key)) {
                    if (! item.Templates || !item.Templates.L) {
                        item.Templates = { L: [] };
                    }
                    item.Templates.L.push({
                        M: {
                            Value: { S: key },
                            avType: { S: avType },
                            Label: { S: label },
                            Columns: { L: [] }
                        }
                    });
                }
            };

            item.getTemplate = (templateName) => {
                if (item.templateExists(templateName)) {
                    return item.Templates.L.filter((t) => t.M.Value.S === templateName)[0];
                } else {
                    return undefined;
                }
            };
            // Add / remove columns based upon the selected options collection and the
            // template that it came from
            item.setColumnsFromTemplate = (selectedOptions, template) => {
                // Get the template
                if (! item.templateExists(template.value)) {
                    item.addTemplateIfMissing(template.value, template.avType, template.label);
                }
                // Get the template from this survey
                const t = item.getTemplate(template.value).M;

                // Remove the columns from the template
                let columns = t.Columns.L;
                for (let i=columns.length-1; i>=0; i--) {
                    if (selectedOptions.filter(o => o.ColumnName === columns[i].M.ColumnName.S).length === 0) {
                        t.Columns.L.splice(i,1);
                    }
                };
                // Add columns that are in the selectedOptions but not in the current survey template
                selectedOptions.forEach(o => {
                    // If the column doesn't exist
                    if (t.Columns.L.filter(c => c.M.ColumnName.S === o.ColumnName).length === 0) {
                        // find it in the template, clone it and put it in the current survey template
                        let newColumn = null;
                        if (o.required) {
                            newColumn = template.requiredColumns.filter(nc => nc.M.ColumnName.S === o.ColumnName)[0];
                        } else if (o.templateDefault) {
                            newColumn = template.templateDefaultColumns.filter(nc => nc.M.ColumnName.S === o.ColumnName)[0];
                        } else {
                            newColumn = template.columns.filter(nc => nc.M.ColumnName.S === o.ColumnName)[0];
                        }
                        t.Columns.L.push(JSON.parse(JSON.stringify(newColumn)));
                    }
                });
            };


            item.columnCount = templateName => (item.getTemplate(templateName) ? item.getTemplate(templateName).M.Columns.L.length : 0);
            
            item.getColumns = templateName => {
                if (item.getTemplate(templateName)) {
                    return item.getTemplate(templateName).M.Columns.L.map((c) => c.M);
                } else {
                    return null;
                }
                // if (item.getTemplate(templateName)) {
                //     var a = item.getTemplate(templateName).M.Columns;
                //     var b = this.optionalColumns(a);
                //     return b.map(c => c.M);
                // } else {
                //     return b;
                // }
                //return this.optionalColumns(item.getTemplate(templateName).M.Columns).L.map((c) => c.M);
            };
            
            // The set is required to make sure both the dbObject and simpleObject refer to the correct data
            item.setTemplates = (templates) => {
                this.simpleObject.Templates = this.Templates = templates;
                return this.getSimpleObject();
            }

            // Add all fields that are in the existing survey Templates collection to the
            // selectedTemplatesChosen fields collection
            // it is an object that has one property for each template
            // selectedTemplatesChosenFields.templateName = [field1, 2, 3,...]
            item.getChosenFields = (templatesFromDb, workingFields) => {
                const t = this.simpleObject.Templates;
                if (t && t.L && t.L.length > 0) {
                    let chosenFields = { ...workingFields };
                    t.L.forEach(item => {
                        console.log(item);
                        // Get the current fields in the template stored with thiw survey
                        chosenFields[item.M.Value.S] = this.simpleObject.getColumns(item.M.Value.S).map(c => {
                            return {
                                Label: c.Label.S,
                                ColumnName: c.ColumnName.S,
                                required: (typeof (c.RequiredColumn) === "undefined") ? false : c.RequiredColumn.BOOL,
                                templateDefault:  (typeof (c.TemplateDefault) === "undefined") ? false : c.TemplateDefault.BOOL,
                                nullable: (typeof (c.Nullable) === "undefined") ? true : c.Nullable.BOOL,
                                displayOrder: parseInt(c.DisplayOrder.N, 10),
                                isSeparator: c.DataType.S === "Separator"
                            }
                        });
                        // if nothing has been saved so far this is a newly added template,
                        // don't return anything, the template must have been saved once in order to modifying
                        // the saved columns with this template
                        if (chosenFields[item.M.Value.S].length > 0) {
                            // Get the required field names from the template
                            const cf = requiredFieldNames(templatesFromDb, item.M.Value.S);
                            // Make sure that they exist in this saved template
                            cf.forEach(templateItem => {
                                    let haveMatch = false;
                                    for (let i = 0; i < chosenFields[item.M.Value.S].length; i++) {
                                        if (chosenFields[item.M.Value.S][i].ColumnName === templateItem.ColumnName) {
                                            haveMatch = true;
                                            break;
                                        }
                                    }
                                    if (!haveMatch) {
                                        chosenFields[item.M.Value.S].push(templateItem);
                                        const index = chosenFields[item.M.Value.S].length - 1;
                                        chosenFields[item.M.Value.S][index].required = typeof (templateItem.required) === "undefined" ? false : true;
                                        chosenFields[item.M.Value.S][index].templateDefault = templateItem.templateDefault;
                                        chosenFields[item.M.Value.S][index].nullable = templateItem.nullable;
                                        chosenFields[item.M.Value.S][index].displayOrder = templateItem.displayOrder;
                                        chosenFields[item.M.Value.S][index].isSeparator = (templateItem.dataType === "Separator");
                                    }
                                });
                            // Now need a loop for any items in the saved survey that don't exist in the template anymore
                            chosenFields[item.M.Value.S].forEach(chosenItem => {
                                if (typeof (chosenItem.displayOrder) === "undefined") { //display order won't exist if there was not template
                                    chosenItem.displayOrder = 0;
                                    chosenItem.required = false;
                                    chosenItem.templateDefault = false;
                                    chosenItem.nullable = true;
                                    chosenItem.orphaned = true;
                                }
                            });

                            chosenFields[item.M.Value.S].sort((a, b) => {
                                return (a.displayOrder > b.displayOrder) ? 1 : ((b.displayOrder > a.displayOrder) ? -1 : 0)
                            });
                        }
                    });
                    return chosenFields;
                }
                return [];
            }
        }
    };

    fromDb = (data) => {
        this.dbObject = JSON.parse(JSON.stringify(data));
        
        let item = this.simpleObject = { };
        // set all the help methods on the new simpleObject
        this.setHelperMethods();

        // Set the properties
        item.jobNumVendor = this.getS(this.dbObject.jobNumVendor);
        item.client = this.getS(this.dbObject.client);       
        item.schemaDTS = this.getS(this.dbObject.schemaDTS);
        item.surveyState = this.getS(this.dbObject.surveyState);
        item.technicians = this.getSList(this.dbObject.technicians); //.L
        item.Templates = this.dbObject.Templates; // .L      
        //item.jobnumclient = this.getS(this.dbObject.jobnumclient);
        item.projDesc = this.getS(this.dbObject.projDesc);
        //item.projName = this.getS(this.dbObject.projName);
        item.surveyActivity = this.getS(this.dbObject.surveyActivity);
        //item.surveyName = this.getS(this.dbObject.surveyName);
        item.surveyArea = this.getS(this.dbObject.surveyArea);
        item.createdBy = this.getS(this.dbObject.createdBy);
        item.editedBy = this.getS(this.dbObject.editedBy);
        return this;
    };
}